// client/src/utils/pokerStats/constants.ts

import { Position } from './types';

// ─────────────────────────────────────────────────────────────────────────────
// Position order (desde primero a actuar postflop hasta último)
// ─────────────────────────────────────────────────────────────────────────────
export const POSITION_ORDER: Position[] = ['SB', 'BB', 'EP', 'HJ', 'CO', 'BTN'];

// ─────────────────────────────────────────────────────────────────────────────
// Yuan → USD conversion (para buy-ins en ¥)
// ─────────────────────────────────────────────────────────────────────────────
export const YUAN_TO_USD = 0.14;

// ─────────────────────────────────────────────────────────────────────────────
// Sample size mínimo para mostrar un matchup con confianza en la UI.
// Debajo de esto, el matchup se muestra en gris con flag "insufficient sample".
// ─────────────────────────────────────────────────────────────────────────────
export const MIN_MATCHUP_SAMPLE = 30;

// Sample mínimo para evaluar fold-to-push por bin de stack. Los bins de shoves
// son escasos (solo ocurren cuando hay un shove), así que threshold más bajo.
export const MIN_FOLD_TO_PUSH_SAMPLE = 20;

// Sample size mínimo para evaluar VPIP por posición. Igual que RFI — volumen
// natural alto, threshold conservador para evitar evaluar con ruido.
export const MIN_VPIP_SAMPLE = 50;

// Sample size mínimo para evaluar RFI por posición. RFI tiene mucho más volumen
// natural que matchups de cbet (cada mano genera potencial opp), así que el
// threshold puede ser más alto sin volverse impráctico.
export const MIN_RFI_SAMPLE = 50;

// ─────────────────────────────────────────────────────────────────────────────
// Fase A — Push/Fold short stack
// ─────────────────────────────────────────────────────────────────────────────
// Umbral de stack para considerar un spot como "push/fold territory".
// A <= 15bb el push/fold es claramente la estrategia óptima según teoría.
// A 16-20bb hay más espacio para min-raise correcto en algunos casos.
export const PUSH_FOLD_MAX_STACK_BB = 15;

// Sample mínimo para mostrar push/fold stats con confianza. Menor que
// MIN_RFI_SAMPLE porque el sample natural en short stack es mucho más
// fragmentado (la mayoría del volumen está en BTN/SB, otras posiciones
// casi no ocurren con stack corto).
export const MIN_PUSHFOLD_SAMPLE = 20;

// ─────────────────────────────────────────────────────────────────────────────
// Fase B — CBet Flop por textura
// ─────────────────────────────────────────────────────────────────────────────
// Sample mínimo para evaluar un bucket de textura×posición. Threshold más
// alto que matchup porque solo hay 10 buckets total (5 texturas × 2 pos),
// entonces el volumen por bucket debería ser sustancialmente mayor y vale
// la pena exigir más confianza estadística antes de marcar leaks.
export const MIN_TEXTURE_SAMPLE = 50;

// ─────────────────────────────────────────────────────────────────────────────
// Stack bucket thresholds (en BB)
// ─────────────────────────────────────────────────────────────────────────────
export const STACK_BUCKET_SHORT_MAX = 25;
export const STACK_BUCKET_MID_MAX = 50;

// Rank order para clasificar flops
export const RANK_ORDER = '23456789TJQKA';

// ─────────────────────────────────────────────────────────────────────────────
// Delayed CBet (Hero PFA, flop check-check, Hero apuesta turn)
// ─────────────────────────────────────────────────────────────────────────────
export const MIN_DELAY_CBET_SAMPLE = 30;

// Check-raise flop: threshold más bajo que matchup porque el sample natural
// de XR opps es menor (requiere flop OOP con villain activo).
export const MIN_XRAISE_FLOP_SAMPLE = 20;

// Squeeze y 4bet son spots raros — threshold bajo para no ocultarlos siempre.
export const MIN_SQUEEZE_SAMPLE = 20;
export const MIN_FOURBET_SAMPLE = 15;
